import { lazy } from 'react';

export const ErrorLazy = lazy(() => import('@/pages/starter/Error'));
export const UnAuthorizedLazy = lazy(
  () => import('@/pages/starter/unAuthorized'),
);
export const ChangePasswordLazy = lazy(
  () => import('@/components/modals/ChangePassword'),
);

export const SuperAdminDashboardLazy = lazy(
  () => import('@/pages/superadmin/dashboard'),
);

export const DeviceIdListLazy = lazy(
  () => import('@/pages/admin/device-idenification'),
);
export const ChangeSalesRateLazy = lazy(
  () => import('@/pages/reports/pages/ChangeSalesRate'),
);

export const ChangeTrayNameLazy = lazy(
  () => import('@/pages/reports/pages/change-tray-name'),
);

export const JweleryNewStickerLazy = lazy(
  () => import('@/utils/transaction/jewelry-new-sticker'),
);
export const JAddTemplateLazy = lazy(
  () => import('@/utils/transaction/jewelry-new-sticker/add'),
);
export const BillSetupDesignerLazy = lazy(
  () => import('@/pages/bill-format-designer/BillSetupDesignerPage'),
);
export const ClassicTemplateEditLazy = lazy(
  () => import('@/utils/transaction/jewelry-new-sticker/classic-edit'),
);

export const PermissionMenuMappingLazy = lazy(
  () => import('@/pages/admin/roles/mapping/PermissionMenuMapping'),
);
export const EditPermissionMenuMappingLazy = lazy(
  () => import('@/pages/admin/roles/mapping/EditPermissionMenuMapping'),
);

export const CodeWindowFormModalLazy = lazy(
  () => import('@/components/forms/transaction/purchase/CodeWindowForModal'),
);

export const CodeWindowFormModalSalesReceiveLazy = lazy(
  () =>
    import('@/components/forms/transaction/purchase/ReceiveCodeWindowModal'),
);

export const ReceiveModalLazy = lazy(
  () => import('@/pages/transaction/receive/modal-receive/receive-party-modal'),
);

export const PurchaseWithModalLazy = lazy(
  () => import('@/pages/transaction/purchase-with-modal/Purchase'),
);

export const BranchVersionAssignmentListLazy = lazy(
  () =>
    import(
      '@/pages/superadmin/branchVersionAssignment/BranchVersionAssignmentList'
    ),
);

export const StockAdjustmentListLazy = lazy(
  () =>
    import(
      '@/components/pages/transaction/stock-adjustment/StockAdjustmentList'
    ),
);
export const SalesOrderCodeWindowLazy = lazy(
  () => import('@/components/forms/transaction/purchase/SalesOrderCodeWindow'),
);
export const StockAdjustmentLazy = lazy(
  () =>
    import('@/components/pages/transaction/stock-adjustment/StockAdjustment'),
);
export const CodeWindowStockAdjustmentLazy = lazy(
  () =>
    import(
      '@/components/forms/transaction/purchase/code-window-stock-adjustment'
    ),
);

export const ChangeUserPasswordLazy = lazy(
  () => import('@/pages/starter/auth/ChangeUserPassword'),
);
export const OTPVerificationLazy = lazy(
  () => import('@/pages/starter/auth/OTPVerification'),
);

export const FinancialYearLazy = lazy(
  () => import('@/pages/admin/master/financialYear/FinancialYear'),
);
export const BillSetupListLazy = lazy(
  () => import('@/pages/admin/bill-setup/BillSetupList'),
);
export const StoreSetupListLazy = lazy(
  () => import('@/pages/admin/master/store/StoreList'),
);

export const PurchaseWithModalSalesLazy = lazy(
  () => import('@/pages/transaction/purchase-with-modal-sales/Purchase'),
);
export const BillFormatAdminLazy = lazy(
  () => import('@/pages/admin/master/billFormat'),
);

export const StockCodeLazy = lazy(
  () => import('@/components/pages/transaction/stock/StockCode'),
);
export const StockItemCodeWindowLazy = lazy(
  () => import('@/components/pages/transaction/stock/StockItemCodewindow'),
);

export const CodeWindowLazy = lazy(
  () => import('@/components/forms/transaction/purchase/CodeWindow'),
);
export const ReceiveCodeWindowLazy = lazy(
  () => import('@/components/forms/transaction/receive/ReceiveCodeWindow'),
);

export const UserActivityLazy = lazy(
  () => import('@/pages/user activity/UserActivity'),
);

export const ProductCatalogPageLazy = lazy(
  () => import('@/pages/product/catalog'),
);
export const ProductDetailPageLazy = lazy(
  () => import('@/pages/product/catalog/detail/page'),
);

export const TodayGoldRateLazy = lazy(
  () => import('@/pages/master/todayGoldRate/TodayGoldRate'),
);

export const DashboardLazy = lazy(() => import('@/pages/dashboard/Dashboard'));

export const SubDashboardLazy = lazy(
  () => import('@/pages/dashboard/SubDashboard'),
);
